import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import { TableColumn } from '../../../../ui/components/Common/DataTable/Table';
import { TooltipWrapper } from '../../../job_openings/view/Functions';
import type { IBillingHistory } from '../interfaces';

export const getBillingHistoryColumns = (
  handleDownload: (id: string) => void,
): TableColumn<IBillingHistory>[] => [
  {
    key: 'id',
    label: 'Invoice',
    width: '120px',
    align: 'left',
    render: (row: IBillingHistory) => <TooltipWrapper text={row.id} />,
    disableSort: false,
  },
  {
    key: 'date',
    label: 'Date',
    width: '120px',
    align: 'left',
    render: (row: IBillingHistory) => <TooltipWrapper text={row.date} />,
    disableSort: true,
  },
  {
    key: 'amount',
    label: 'Amount',
    width: '120px',
    align: 'left',
    render: (row: IBillingHistory) => <TooltipWrapper text={row.amount} />,
  },
  {
    key: 'status',
    label: 'Status',
    width: '100px',
    align: 'left',
    render: (row: IBillingHistory) => (
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>
        <Chip
          label={row.status}
          size="small"
          color="success"
          sx={{
            fontWeight: 800,
            fontSize: '0.625rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            borderRadius: 2,
            height: 22,
          }}
        />
      </Box>
    ),
  },
  {
    key: 'method',
    label: 'Method',
    width: '150px',
    align: 'left',
    render: (row: IBillingHistory) => <TooltipWrapper text={row.method} />,
  },
  {
    key: 'actions',
    label: 'Actions',
    width: '120px',
    align: 'right',
    render: (row: IBillingHistory) => (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', textAlign: 'left' }}>
        <Button
          size="small"
          onClick={() => handleDownload(row.id)}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '0.75rem',
            color: 'primary.main',
            p: 0,
            minWidth: 'auto',
            '&:hover': { textDecoration: 'underline', bgcolor: 'transparent' },
          }}
        >
          Download PDF
        </Button>
      </Box>
    ),
  },
];
